import { useEffect } from "react";

export const GOOGLE_TAG_MANAGER_ID = import.meta.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;

export default function GTagHeader() {
    useEffect(() => {
        if (!GOOGLE_TAG_MANAGER_ID) return;

        const script = document.createElement("script");
        script.id = "google-tag-manager-init";
        script.innerHTML = `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', 'GTM-${GOOGLE_TAG_MANAGER_ID}');
        `;
        document.head.appendChild(script);

        return () => {
            const el = document.getElementById("google-tag-manager-init");
            if (el) el.remove();
        };
    }, []);

    return null;
}
